<transition name="modal">
  <div class="modal-mask task-modal-mask calculated-picker-modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <app-sub-navigation-bar
          back-label="Back to task"
          @back="$emit('close')"
        />

        <div class="task-modal-shell">
          <div class="task-modal-body">
            <h4 class="task-modal-title">Select Product</h4>

            <form class="ui form task-modal-picker-filters" v-on:submit.prevent>
              <div class="field">
                <app-field-label>Type</app-field-label>
                <app-select
                  :defaultLabel="'All products'"
                  :items="pipeTypeSelectItems"
                  :value="''"
                  @selected="filterByType($event.id)"
                />
              </div>
              <div class="field">
                <app-field-label>Search</app-field-label>
                <app-text-input
                  icon="search"
                  placeholder="Search product name"
                  v-model="search"
                  v-on:keyup="filterByDescription(search)"
                />
              </div>
            </form>

            <div class="task-modal-picker-list-header">
              <span></span>
              <span class="task-modal-picker-list-header__label">Description</span>
            </div>

            <div
              v-for="material in materials"
              :key="material.id || material.description"
              class="task-modal-picker-row"
              @click="setPipe(material)"
            >
              <div class="task-modal-picker-row__image">
                <img v-if="getImageUrl(material)" :src="getImageUrl(material)" :alt="material.description || ''">
                <img v-else src="../../../../assets/img/no-image-available.jpg" alt="">
              </div>
              <div class="task-modal-picker-row__label">{{ displayCatalogName(material.description) }}</div>
            </div>

            <app-loader v-if="loading === true"></app-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</transition>
